// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--r1_pS","element":"da51a739f7--element--hED02"};